import ReactDOM from 'react-dom';
import './App.css';
import App from 'app';
import { AppProviders } from 'context';
import reportWebVitals from './reportWebVitals';
import './styles/styles.css';
import './globals';
import { MantineProvider } from '@mantine/core';
import theme from './mantine.config';

ReactDOM.render(
  <AppProviders>
    <MantineProvider theme={theme}>
      <App />
    </MantineProvider>
  </AppProviders>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
